import React, {useEffect, useRef, useState} from "react";
import CambioIdioma from "../scripts/CambioIdioma";
import Datos from "../../utilidades/Colecciones.json";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
const SelectBuscadorCole = (() => {
    const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
    const [options, setOptions] = useState([]);
    const pestanaLabel = useRef(null);
    const selectPestana = useRef(null);
    const [selectedOption, setSelectedOption] = useState("");
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
    }
    const handleSelectChange = (event) => {
      const coleccion = event.target.value;
      if (coleccion === "Todo") {
        document.getElementById('contextsearchresults').style.marginTop = "50px";
        document.getElementById('Slp-tbl-row_buscador').classList.remove("saltoLineas");
      }
      else {
        document.getElementById('contextsearchresults').style.marginTop = "0px";
        document.getElementById('Slp-tbl-row_buscador').classList.add("saltoLineas");
      }
      if (coleccion === "Indicadores"){
        document.getElementById('Slp-tbl-row_buscador').style.marginTop = "45px";
      }
      else if (coleccion === "Todo"){
        document.getElementById('Slp-tbl-row_buscador').style.marginTop = "10px";
      }
      else{
        document.getElementById('Slp-tbl-row_buscador').style.marginTop = "25px";
      }


      setSelectedOption(coleccion);
      _updateFiltros({coleccion:coleccion});
      _updateFiltros({paginaFin:10});
      document.getElementById('resultados').innerHTML= 0;
      if(document.getElementById("info")){
        let selectElement = document.getElementById("info");
        const option = selectElement.querySelector(`option[value="10"]`);
        option.setAttribute('selected', 'selected');
        const event = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(event);
      }
      $("#search").trigger("click");
    }
    useEffect(() => {
        if (pestanaLabel !== null) {
            CambioIdioma.valida(var_ingles, pestanaLabel);
        }
        if (selectPestana !== null) {
          let x=[];
            if (var_ingles === "es") {
                setOptions(Datos[0].colecciones.español);
                x=Datos[0].colecciones.español;
            } else {
                setOptions(Datos[0].colecciones.ingles);
                x=Datos[0].colecciones.ingles;
            }
          const valor = x[0].value;
          _updateFiltros({coleccion:valor});
        }
    }, []);
    return(
        <div className="col-sm-12 col-md-11 col-lg-5" id="coleccionesCombo" >
          <div id="pestana1">
            <div className="row">
              <div
                className="form-check-inline col-sm-12 col-md-11 col-lg-1 col-11"
                style={{ paddingRight: "40px" }} 
              >
                <div id="labelPestana">
                  <span id="pestanaLabel" ref={pestanaLabel}></span>
                </div>
              </div>
              <div
                className="form-check-inline col-md-11 col-lg-7 col-11"
                id="selectPestanaPrincipal"
              >
                <div id="comboPestana">
                  <select
                    className="form-select"
                    ref={selectPestana}
                    value={selectedOption}
                    onChange={handleSelectChange}
                    name="Pestana"
                    id="selectPestana"
                  >
                    {options.map((option,i) => (
                      <option key={"coleccionesBuscador-" + i} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
});
export default SelectBuscadorCole;